import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectProjectSettings } from '@/store/slices/project/selectors';
import { EPaletteModes } from '@/types/theme-packs.types';

const useGetWorkingProjectThemeMode = () => {
  const projectSettings = useAppSelector(selectProjectSettings);

  return useMemo(() => {
    return projectSettings?.design?.color_theme || projectSettings?.design?.colors?.theme_mode || EPaletteModes.Dark;
  }, [projectSettings]);
};

export default useGetWorkingProjectThemeMode;
